import { request } from "@/service";
import setupConstants from "@/modules/setup/setupConstants";
import EventBus from "@/utils/eventBus";
import { isArray, isObject } from "lodash";

export default {
  namespaced: true,

  state: {
    stages: [],
    reviewStages: [],
    memberType: [],
    subscriptionPeriod: [],
    reviewers: [],
    reviewStageChecklist: [],
    reviewStageChecklistDialog: false,
    checklistDocumentNo: null,
    stageChecklist: [],
    documentReviewChecklistRecorded: false,
    profileDiscipline: [],
  },

  mutations: {
    SET_MEMBER_TYPES: (state, payload) => {
      state.memberType = payload;
    },
    SET_REVIEW_STAGES: (state, payload) => {
      state.reviewStages = payload;
    },
    SET_SUBSCRIPTION_PERIOD: (state, payload) => {
      state.subscriptionPeriod = payload;
    },

    SET_REVIEWERS: (state, payload) => {
      state.reviewers = payload;
    },

    SET_STAGES: (state, payload) => {
      state.stages = payload;
    },
    SET_REVIEW_STAGE_CHECLISTS: (state, payload) => {
      state.reviewStageChecklist = payload;
    },
    SET_REVIEW_STAGE_CHECKLIST_DIALOG: (state, payload) => {
      state.reviewStageChecklistDialog = payload.state;
      if (payload.checklist) {
        state.stageChecklist = payload.checklist;
      }
      if (payload.documentNo) {
        state.checklistDocumentNo = payload.documentNo;
      }
    },
    SET_DOCUMENT_REVIEW_CHECKLIST_RECORDED: (state, payload) => {
      state.documentReviewChecklistRecorded = payload;
    },
    SET_PROFILE_DISCIPLINE: (state, payload) => {
      state["profileDiscipline"] = payload;
    },
  },

  getters: {
    subscriptionPeriod: (state) => state.subscriptionPeriod,
    memberType: (state) => state.memberType,
    reviewers: (state) => state.reviewers,
    stages: (state) => state.stages,
    reviewStage: (state) => state.reviewStages,
    reviewStageChecklist: (state) => state.reviewStageChecklist,
    reviewStageChecklistDialog: (state) => state.reviewStageChecklistDialog,
    checklistDocumentNo: (state) => state.checklistDocumentNo,
    stageChecklist: (state) => state.stageChecklist,
    documentReviewChecklistRecorded: (state) =>
      state.documentReviewChecklistRecorded,
    getProfileDiscipline: (state) => state["profileDiscipline"],
  },

  actions: {
    getMemberTypes({ commit }) {
      request("get", setupConstants.memberType)
        .then((res) => {
          commit("SET_MEMBER_TYPES", res.data.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },

    getSubscriptionPeriods({ commit }) {
      request("get", setupConstants.subscriptionPeriod)
        .then((res) => {
          commit("SET_SUBSCRIPTION_PERIOD", res.data.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },

    getReviewers({ commit }) {
      request("get", setupConstants.reviewers)
        .then((res) => {
          commit("SET_REVIEWERS", res?.data?.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err?.response?.data?.message,
          });
          console.log(err);
        });
    },

    getStages({ commit }) {
      request("get", setupConstants.stages)
        .then((res) => {
          commit("SET_STAGES", res.data.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },
    fetchProfileDiscipline({ commit }) {
      request("get", setupConstants.profileDiscipline)
        .then((res) => {
          commit("SET_PROFILE_DISCIPLINE", res.data.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },
    getReviewStages({ commit }) {
      request("get", setupConstants.reviewStages)
        .then((res) => {
          commit("SET_REVIEW_STAGES", res.data.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },
    getReviewChecklist({ commit }) {
      request("get", setupConstants.stagechecklists)
        .then((res) => {
          commit("SET_REVIEW_STAGE_CHECLISTS", res.data.data);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },
    getDocumentReviewChecklistRecord({ commit }, params) {
      request("get", setupConstants.getRecordedDocumentReviewChecklist(params))
        .then((res) => {
          let record = false;
          if (isArray(res?.data?.data) && res?.data?.data.length) {
            record = true;
          } else if (
            isObject(res?.data?.data) &&
            Object.keys(res?.data?.data)?.length
          ) {
            record = true;
          }
          commit("SET_DOCUMENT_REVIEW_CHECKLIST_RECORDED", record);
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err?.response?.data?.message,
          });
          console.log(err);
        });
    },
    submitStageChecklistRecord({ commit }, payload) {
      request("post", setupConstants.submitStageChecklist, payload)
        .then((res) => {
          commit("SET_ALERT", {
            status: "success",
            message: res.data.message,
          });
          commit("SET_REVIEW_STAGE_CHECKLIST_DIALOG", {
            state: false,
            checklist: [],
          });
          EventBus.$emit("SEND_PAYLOAD");
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          console.log(err);
        });
    },
  },
};
